module.exports = __webpack_public_path__ + "img/samsung.69be5284.jpeg";